<template>
  <div class="head-container">
    <div class="content">
      <div class="heading">
        {{ text }}
        <br>
        <!-- <i class="material-icons heading-icon">{{ icon}}</i> -->
      </div>
      <div class="actions">
        <slot></slot>
        <!--<div class="add-button elevation-0">Add Book</div>-->
      </div>
      <div class="clearfix"></div>
      <!--<div class="description">-->
      <!--4 Books-->
      <!--</div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Head",
  props: ["text", "icon", "name"]
};
</script>

<style scoped>
.container {
  width: 100%;
  padding: 0;
}
.head-container {
  width: 100%;
  background: #fff;
  border-bottom: 0px solid #f4f4f4;
}
.content {
  max-width: 1180px;
  margin: 0 auto;
  border-bottom: 0px solid #fff;
  padding: 24px 0 20px 0;
}
.heading {
  margin-left: 0px;
  padding: 0 0 0em 0.2em;
  font-weight: 600;
  font-size: 12pt;
  letter-spacing: -0.5px;
  font-family: "Source Sans Pro";
  color: #fff;
  text-align: center;
}
.heading-icon {
  font-size: 20pt;
  color: #ff5722;
}
.actions {
  display: none;
  float: right;
}
.add-button {
  background: #2196f3 !important;
  margin-top: 10px;
  /*border: 2px solid #e3e3e3;*/
  /*border-bottom: 3px solid #c6c6c6;*/
  border-radius: 4px;
  padding: 7px 18px;
  font-size: 14pt;
  font-weight: 700;
  text-transform: none;
  color: #fff !important;
  font-family: "Source Sans Pro";
}
.plus {
  display: inline-block;
  padding: 0 0.2em 0 0;
}
.add-button .v-btn__content {
}
.subheading {
  padding-top: 2px;
  font-size: 14pt !important;
  font-weight: 700;
  color: #1565c0;
}
.action-button {
  float: left;
  margin-top: 8px;
  padding: 6px 16px;
  background: #fff;
  height: 32px;
  border-radius: 8px;
}
</style>